import { httpClient } from "./RestService";

export const health = async () => {

  // https://www.backend.bizcaselab.com/actuator/health
  return await httpClient().get("/actuator/health");
};
